module.exports = __webpack_public_path__ + "img/packageList.cc20ff30.png";